<template>
  <td :class="customClass">
    <slot>
      {{ row[field] }}
    </slot>
  </td>
</template>

<script>
export default {
  name: 'DTableColumn',
  
  props: {
    field: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    sortable: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    },
    class: {
      type: String,
      default: ''
    }
  },
  
  computed: {
    customClass() {
      return this.class;
    }
  },
  
  created() {
    // Register this column with parent table if needed
    if (this.$parent && this.$parent.registerColumn) {
      this.$parent.registerColumn({
        field: this.field,
        label: this.label,
        sortable: this.sortable
      });
    }
  }
};
</script>